module.exports = __webpack_public_path__ + "static/media/carpentry.a537330a.svg";